import * as React from 'react';
import { Repeat2Icon } from 'lucide-react';
import { cn } from 'lib/utils';

type Props = React.ComponentProps<'div'>

export const ReturnStatusIconAndLabel = ({ className, ...props }: Props) => {
  return (
    <div
      {...props}
      className={cn(
        'flex items-center justify-center p-2 rounded-md gap-2',
        'bg-red-500 text-slate-50',
        className,
      )}>
      <Repeat2Icon className={'w-4 h-4'} />
      <span>Devolução</span>
    </div>
  );
};